import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface, ClientType } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetTutorsUseCase implements UseCase<Observable<Transaction<ClientInterface[]>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<ClientInterface[]>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        const tutors: ClientInterface[] = [];

                        contract.holders.map((holder) => {
                            if (holder.type === ClientType.NATURAL_PERSON) {
                                tutors.push(cloneDeep(holder));
                            }
                        });

                        contract.authorized.map((authorized) => {
                            if (authorized.type === ClientType.NATURAL_PERSON) {
                                tutors.push(cloneDeep(authorized));
                            }
                        });

                        contract.legalGuardians.map((legalGuardian) => {
                            if (
                                legalGuardian.type === ClientType.NATURAL_PERSON &&
                                !tutors.find((it) => it.id.value === legalGuardian.id.value)
                            ) {
                                tutors.push(cloneDeep(legalGuardian));
                            }
                        });

                        return Transaction.success(tutors);
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
